import { faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InfoIcon, Play } from "lucide-react";
import React from "react";
import { Mixpanel } from "../../config/Mixpanel";
import Constants from "../../common/constants";

const weekInfo = [
  {
    id: 1,
    title: "Building The Ultimate Profile",
    description: "CV + LinkedIn revamp to make your application stand out",
  },
  {
    id: 2,
    title: "Creating Your Job Hunt Plan",
    description: "Learn winning strategies that will get you shortlisted",
  },

  {
    id: 3,
    title: "Mastering The Elevator Pitch",
    description:
      "Land multiple job interviews with the right skills & attitude",
  },
  {
    id: 4,
    title: "Live Interview Training",
    description: "Get hired with mock interviews & personalised feedback",
  },
];

const CareerGuidanceFeature = ({
  stepNumber = 2,
  onExploreClick,
  weekModalInfo,
  setYoutubeModal,
  setShowModal,
}) => {
  return (
    <div className="relative flex w-full flex-col items-center rounded-xl bg-[rgba(64,106,255,0.05)] px-6 pb-6 pt-0 shadow-[0px_-4px_20px_0px_rgba(0,0,0,0.3)] backdrop-blur-[7.5px]">
      {/* Top decorative element */}
      <img
        alt=""
        className="-mt-5 h-[50px] w-full"
        src="https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/Ellipse%201270.png"
      />

      {/* Main content container */}
      <div className="relative flex w-full flex-col items-center gap-4">
        {/* Header section with step number and title */}
        <div className="relative flex w-full flex-col items-center gap-3">
          {/* Step number badge */}
          <div className="relative flex h-6 w-6 items-center justify-center rounded-[24px] border-[1.5px] border-solid border-[#c1dcff] p-[10px]">
            <p
              className="font-['Inter'] text-[14px] font-bold leading-none tracking-[-0.14px]"
              style={{
                background: "linear-gradient(180deg, #c1dcff 0%, #406aff 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              {stepNumber}
            </p>
          </div>

          {/* Title and description */}
          <div className="flex w-full flex-col items-center gap-[6px]">
            <h2
              className="flex items-center text-center font-['Inter'] text-[16px] font-bold capitalize leading-none tracking-[-0.16px]"
              style={{
                background:
                  "linear-gradient(90deg, rgba(193, 220, 255, 1) 0%, rgba(13, 91, 249, 1) 117.87%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              100% Placement Support{" "}
              <InfoIcon
                size={20}
                className="ml-1 cursor-pointer text-white"
                onClick={() => {
                  Mixpanel.track(
                    Constants.Mixpanel
                      .ONBOARDING_PAGE_25_PLACEMENT_SUPPORT_WEEK_MODAL_OPENED,
                  );
                  setShowModal(true);
                }}
              />
            </h2>

            <p className="max-w-full whitespace-pre-wrap text-center font-['Inter'] text-[12px] font-normal leading-[1.4] text-[rgba(255,255,255,0.7)]">
              A lifetime placement assistance as a valued LearnTube Learner
            </p>
          </div>
        </div>

        <div className="flex w-full items-center justify-center gap-4 md:w-[80%]">
          <img
            alt=""
            src="https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/Stats/Frame%20427322005.webp"
            className="w-[30%]"
          />
          <div className="flex flex-1 flex-col items-center justify-center gap-2">
            {weekInfo?.map((item, index) => (
              <div
                key={item?.index}
                className="flex w-full cursor-pointer flex-col items-start justify-start"
                onClick={() => {
                  Mixpanel.track(
                    Constants.Mixpanel
                      .ONBOARDING_PAGE_25_PLACEMENT_SUPPORT_WEEK_MODAL_OPENED,
                  );
                  setYoutubeModal({
                    info: weekModalInfo[index],
                    is_open: true,
                  });
                }}
              >
                <div className="w-full rounded-3xl py-0 pr-0">
                  <div
                    className="flex items-center  justify-between rounded-3xl py-2 px-4"
                    style={{
                      boxShadow: `4px 4px 7px 0 rgba(11, 29, 43, 0.7)`,
                      backgroundImage: `linear-gradient(
    to right,
    rgba(64, 106, 255, 0.2) 0%,
    rgba(38, 64, 153, 0.2) 100%
  )`,
                    }}
                  >
                    <div className="w-full text-left">
                      <div className="text-[9px] font-bold text-[#70AEFF] md:text-[11px]">
                        WEEK {index + 1}
                      </div>
                      <div className="mt-1 text-[10px] font-medium text-white md:text-[12px]">
                        {item?.title}
                        <FontAwesomeIcon
                          icon={faPlay}
                          className="ml-1 text-white md:ml-2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex w-full gap-4 whitespace-nowrap  text-[10px] text-white/50 md:w-[80%]">
          & Others From{" "}
          <img
            alt=""
            className="w-full"
            src="https://img.learntube.ai/public-assets/academy%20placement/Frame%20427322287.svg"
          />
        </div>
      </div>
    </div>
  );
};

export default CareerGuidanceFeature;
